export function postsReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_POST":            
        case "UPDATE_POST":
            let list = Object.assign({}, state);
            list[payload.post_id] = payload
            
            return list
        case "DELETE_POST":            
            let list2 = Object.assign({}, state);
    
            delete list2[payload.post_id]
            return list2
        case "GET_POSTS":
            return payload
        default:
            return state;
    }
    
}